/*
 * Copyright (c) 2022 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */


import { action, computed } from 'mobx';
import {
  FC_Portal_LaunchDarklyEnvKeyName,
  launchDarklyFeatureToggleKey
} from '../../launchDarklyConfig';
import { LDClient, LDUser } from 'launchdarkly-js-client-sdk';
import FeatureFlagStore from './FeatureFlagsStore';
// NOTE:
// - flags are mobx observable either from the flags or your own computed
// property for convenience
// - you can use flags in stores or other non-React.Component locations
// (functions/classes) but the value can not be "reactive" outside a Component.


/**
 * FeatureFlagStore for Forge Connect PLatform LaunchDarkly (Currently it's connected to the 'gatewaymanagerdiyapp' microservice launchdarkly)
 */
export class FCPFeatureFlagsStore extends FeatureFlagStore {

  getLaunchDarklyEnvKey(){
    return this.envVariables[FC_Portal_LaunchDarklyEnvKeyName];
  }

  @action
  setFeatureFlags = (client: LDClient) => {
    this.featureFlags['fcpEPMDIYAppEnabled'] = client.variation(launchDarklyFeatureToggleKey.FC_PORTAL.EPM_DIY_GW_REG_FEATURE_KEY, false);
  };

  getLDUserInfo = (): LDUser => {
    const sessionStorageKey = `oidc.user:${this.envVariables.FORGE_IAM_AUTHORITY}:${this.envVariables.FC_CLIENT_ID}`;
    const userProfile = JSON.parse(sessionStorage.getItem(sessionStorageKey) || '{}')['profile'];
    const customerProjectID = this.getCustomerProjectId();
    const ldUser: LDUser = {
      key: userProfile?.['sub'] || '',
      name: userProfile?.['preferred_username'],
      custom: {
        tenant: customerProjectID,  //get the current projectId of user
      },
    };
    return ldUser;
  }

  @computed
  get getFCPEPMDIYAppEnabled() {
    return this.featureFlags['fcpEPMDIYAppEnabled'];
  }

  getCustomerProjectId = () =>{
    const sessionStorageKey = `oidc.user:${this.envVariables.FORGE_IAM_AUTHORITY}:${this.envVariables.FC_CLIENT_ID}`;
    const userProfile = JSON.parse(sessionStorage.getItem(sessionStorageKey) || '{}')['profile'];
    const customerProjectID = userProfile.customer.replace('-default-customer','');
    return customerProjectID;
  }
}
export default new FCPFeatureFlagsStore();
